import { API } from "../api";

export const appScopeReducer = (draft, action) => {
  switch (action.type) {
    case "SELECT_ELEMENT":
      draft.selectedElement = action.payload.selectedElement;
      draft.selectedElementType = action.payload.selectedElementType;
      break;
    case "ONCHANGE_ELEMENT":
      draft[draft.selectedTemplate][action.payload.name].text =
        action.payload.value;
      break;
    case "ONCHANGE_COLOR":
      draft[draft.selectedTemplate][action.payload.name].color =
        action.payload.value;
      break;
    case "ONCHANGE_IMAGE_TEXT":
      draft[draft.selectedTemplate][action.payload.selectedElement][
        action.payload.name
      ] = action.payload.value;
      break;
    case "ONCHANGE_BANNER_IMAGE":
      draft[draft.selectedTemplate][draft.selectedElement].url =
        action.payload.url;
      break;
    case "ONCLICK_SECTION_STORE":
      draft.storeTemplate.isSectionVisible[action.payload.name] =
        !draft.storeTemplate.isSectionVisible[action.payload.name];
      break;
    case "ON_SEO_TEXT_CHANGE":
      draft[action.payload.name] = action.payload.value;
      break;
    case "ON_CATEGORY_CLICK":
      draft.selectedElement = action.payload.selectedElement;
      draft.selectedElementType = action.payload.selectedElementType;
      draft.index = action.payload.index;
      break;
    case "ON_CATEGORY_LINK_CHANGE":
      draft.storeTemplate.categories[draft.index].link = action.payload.value;
      break;
    case "ON_ADD_FAV":
      draft.storeTemplate.favCategories = [
        ...draft.storeTemplate.favCategories,
        {
          title: "title",
          des1: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          des2: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          btnText: "text",
          btnBgColor: "#3B513D",
          btnColor: "#ffffff",
          titleColor: "#3B513D",
          desColor: "#000000",
        },
      ];
      break;
    case "ON_DELETE_FAV":
      draft.storeTemplate.favCategories =
        draft.storeTemplate.favCategories.filter(
          (item, i) => i !== action.payload.index
        );
      break;
    case "ONCHANGE_FAV":
      draft.storeTemplate.favCategories[action.payload.index][
        action.payload.name
      ] = action.payload.value;
      break;
    case "ON_FAV_TEXT_CLICK":
      draft.selectedElement = action.payload.selectedElement;
      draft.index = action.payload.index;
      draft.selectedElementType = action.payload.selectedElementType;
      break;
    case "ON_FAV_TEXT_CHANGE":
      draft.storeTemplate.favCategories[action.payload.index][
        action.payload.name
      ] = action.payload.value;
      break;
    case "DELETE_LOGO":
      draft.storeTemplate[action.payload.selectedElement] = draft.storeTemplate[
        action.payload.selectedElement
      ].filter((item, i) => i !== action.payload.index);
      break;
    case "ON_ADD_LOGO":
      draft.storeTemplate[action.payload.selectedElement] = [
        ...draft.storeTemplate[action.payload.selectedElement],
        {
          show: true,
          btnColor: "#ffffff",
          link: "",
          logo: action.payload.logo,
        },
      ];
      break;
    case "ON_SELECT_LOGO":
      draft.selectedElement = action.payload.selectedElement;
      draft.index = action.payload.index;
      draft.selectedElementType = action.payload.selectedElementType;
      break;
    case "ON_WE_ARE_AVAILABLE_CHANGE":
      draft.storeTemplate.weAreAvailable[draft.index][action.payload.name] =
        action.payload.value;
      break;
    case "ON_SUPPOERTERS_CHANGE":
      draft.storeTemplate.proudlySupp[draft.index][action.payload.name] =
        action.payload.value;
      break;
    case "ON_SHOW_HIDE_LOGO":
      draft.storeTemplate[action.payload.selectedElement][
        action.payload.index
      ].show =
        !draft.storeTemplate[action.payload.selectedElement][
          action.payload.index
        ].show;
      break;
    case "ON_TEXT_BOX_CHANGE":
      draft.storeTemplate[action.payload.name] = action.payload.value;
      break;
    case "ON_SET_STORES":
      draft.stores = action.payload.data;
      break;
    case "ON_SET_CATEGORIES":
      draft.storeTemplate.categories = action.payload.data;
      break;
    case "ON_SET_SELECTED_STORE":
      draft.selectedStore = action.payload.store;
      draft.storeTemplate.bannerTitle1.text = action.payload.store.name;
      break;
    case "ON_ORDER_ONLINE_SECTION_CHANGE":
      draft.storeTemplate.orderOnlineSection[action.payload.name] =
        action.payload.value;
      break;
    case "UPDATE_STATE":
      const {
        gtm,
        meta_description,
        meta_keyword,
        meta_title,
        selectedTemplate,
        slug,
        title,
        storeTemplate,
        selectedStore,
        id,
        status,
        initialSlug,
        opening_hours,
        openday_text,
        custom,
      } = action.data;
      const { selectedElement, selectedElementType, index } = initialData;
      if (storeTemplate) {
        draft.storeTemplate = storeTemplate;
      }
      draft.custom = custom;
      draft.initialSlug = initialSlug;
      draft.id = id;
      draft.status = status;
      draft.gtm = gtm;
      draft.meta_description = meta_description;
      draft.meta_keyword = meta_keyword;
      draft.meta_title = meta_title;
      draft.opening_hours = opening_hours;
      draft.openday_text = openday_text;
      draft.selectedTemplate = selectedTemplate;
      draft.slug = slug;
      draft.title = title;
      draft.selectedStore = selectedStore;
      draft.selectedElement = selectedElement;
      draft.selectedElementType = selectedElementType;
      draft.index = index;
      draft.mobile_body = action.data?.mobile_body ?? null;
      draft.mobile_body_enabled = action.data?.mobile_body_enabled ?? false;
      break;
    case "RESET_STATE":
      draft.id = null;
      draft.status = null;
      draft.initialSlug = "";
      draft.gtm = "";
      draft.meta_description = "";
      draft.meta_keyword = "";
      draft.meta_title = "";
      draft.slug = "";
      draft.title = "";
      draft.custom = initialData.custom;
      draft.mobile_body = null;
      draft.mobile_body_enabled = false;
      draft.openday_text = "";
      draft.opening_hours = [];
      draft.selectedStore = initialData.selectedStore;
      draft.selectedElement = initialData.selectedElement;
      draft.selectedElementType = initialData.selectedElementType;
      draft.index = initialData.index;
      break;
    case "ON_CUSTOM_CHANGE":
      draft.custom = action.payload.data;
      break;
    case "ON_CUSTOM_MOBILE_CHANGE":
      draft.mobile_body = action.payload.data;
      break;
    case "SET_TEMPLATE_TYPE":
      draft.selectedTemplate = action.payload.data;
      break;
    case "CHANGE_TAB":
      draft.currentTab = action.payload.tab;
      break;
    default:
      break;
  }
};

export const onElementClick = (dispatch, element, type) => {
  dispatch({
    type: "SELECT_ELEMENT",
    payload: {
      selectedElement: element,
      selectedElementType: type,
    },
  });
};

export const onTextChange = (dispatch, name, value) => {
  dispatch({
    type: "ONCHANGE_ELEMENT",
    payload: {
      name,
      value,
    },
  });
};

export const onDeleteLogo = (dispatch, ele, index) => {
  dispatch({
    type: "DELETE_LOGO",
    payload: {
      selectedElement: ele,
      index,
    },
  });
};
export const onAddLogo = (dispatch, ele, e) => {
  const formData = new FormData();
  formData.append("image", e.target.files[0]);
  API.post("image-upload", formData)
    .then((res) => {
      if (res.data.statusCode === 200) {
        dispatch({
          type: "ON_ADD_LOGO",
          payload: {
            selectedElement: ele,
            logo: res.data.data.image_url,
          },
        });
      }
    })
    .catch((err) => console.log(err));
};

export const onSelectLogoElement = (dispatch, ele, type, index) => {
  dispatch({
    type: "ON_SELECT_LOGO",
    payload: {
      selectedElement: ele,
      selectedElementType: type,
      index,
    },
  });
};

export const onShowHideLogoElement = (dispatch, ele, index) => {
  dispatch({
    type: "ON_SHOW_HIDE_LOGO",
    payload: {
      selectedElement: ele,
      index,
    },
  });
};

export const getStoreList = (dispatch) => {
  API.get("store-list")
    .then((res) => {
      if (res.data.statusCode === 200) {
        dispatch({
          type: "ON_SET_STORES",
          payload: {
            data: res.data.data,
          },
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getCategories = (dispatch) => {
  API.get("category-list")
    .then((res) => {
      if (res.data.statusCode === 200) {
        const data = res.data.data.map((item) => ({ ...item, link: "" }));
        dispatch({
          type: "ON_SET_CATEGORIES",
          payload: {
            data,
          },
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const initialData = {
  currentTab: 1,
  previousLocation: "",
  selectedElement: "bannerTitle1",
  selectedElementType: "text",
  index: 0,
  stores: [],
  id: null,
  initialSlug: "",
  status: null,
  selectedStore: {},
  selectedTemplate: "storeTemplate",
  title: "",
  slug: "",
  meta_titile: "",
  meta_description: "",
  meta_keyword: "",
  gtm: "",
  opening_hours: [],
  openday_text: "",
  custom: `<figure class="image image_resized" style="width:99.36%;"><img src="https://banjosdev.codinghands.in/storage/pagetemplate/QY5iWRomAWwmbdNIxw7j8KejFkDOAxpY6Ovix2op.jpg"></figure><p>&nbsp;</p><figure class="table" style="width:76.87%;"><table><colgroup><col style="width:100%;"></colgroup><tbody><tr><td><h2>Page Title</h2><p>&nbsp;</p><figure class="image image_resized image-style-side" style="width:19.45%;"><img src="https://banjosdev.codinghands.in/storage/pagetemplate/aXkQJU1JiJrY2m1Hs4Br4Vqf7XTEU5xF99RxfFSW.jpg"></figure><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p><p>&nbsp;</p><h3>Heading 2</h3><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.&nbsp;</p><p>&nbsp;</p><h3>Heading 2</h3><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.&nbsp;</p></td></tr></tbody></table></figure><h2>&nbsp;</h2><p>&nbsp;</p><p style="text-align:justify;">&nbsp;</p>`,
  mobile_body: null,
  mobile_body_enabled: false,
  storeTemplate: {
    bannerTitle1: {
      componentName: "Banner Title 1",
      text: "",
      color: "#fffceb",
    },
    bannerImage1: {
      componentName: "Banner 1",
      url: "https://banjosdev.codinghands.in/storage/eZswjL5Yg7tzoxFUKUEWVsRYo3ba4c39L8fX6GMR.jpg",
      alt: "Banner 1",
      imageSchema: "",
      imageDescription: "Banner 1",
    },
    categoryTitle: {
      componentName: "Category Title",
      text: "ORDER",
      color: "#000000",
    },
    categories: [],
    bannerTitle2: {
      componentName: "Banner Title 2",
      text: "Australia's local bakery",
      color: "#fffceb",
    },
    bannerImage2: {
      componentName: "Banner 2",
      url: "https://banjosdev.codinghands.in/storage/JEn3kQklketPoLlCWfzua82Mk3ofiUsH5nICfWrv.jpg",
      alt: "",
      imageSchema: "",
      imageDescription: "",
    },
    doodleImage: {
      componentName: "Doodle Image",
      url: "https://banjosdev.codinghands.in/storage/ujRMgNyQ5bUFNSX3FHiH3lXNzTXwvBpOPDOovGCM.jpg",
      alt: "",
      imageSchema: "",
      imageDescription: "",
    },
    descriptionBox1:
      "<h1>Your heading</h1>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.",
    descriptionBox2:
      "<h1>Your heading</h1>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.",
    bannerTitle3: {
      componentName: "Banner Title 3",
      text: "The Great Australian bite",
      color: "#fffceb",
    },
    bannerImage3: {
      componentName: "Banner 3",
      url: "https://banjosdev.codinghands.in/storage/XKmg7Eyi1A5ypgpvbBNv4gcUsqLB7NVszjvgTfvg.jpg",
      alt: "",
      imageSchema: "",
      imageDescription: "",
    },
    orderOnlineSection: {
      backgroundColor: "#fffceb",
      headerText: "Order Online with Store name",
      headerColor: "#564845",
      description:
        "Store name is available for online ordering through the Banjo's App & Doordash. Order Online and skip the cue through the links below:",
      descriptionColor: "#808080",
      btnText: "Order Now",
      btnBgColor: "#564845",
      btnColor: "#fffceb",
      link: "",
    },
    favCategories: [
      {
        title: "Hot Savouries",
        des1: "Open from 6am, start your morning off right with Banjo’s Beerwah. Try barista made coffee, freshly made toasties, breakfast croissants or our house made melts. ",
        des2: "For the perfect breakfast pair, try our everyday Coffee & Toastie deal from only $8.20.",
        btnText: "BREAKFAST",
        btnBgColor: "#3B513D",
        btnColor: "#ffffff",
        titleColor: "#3B513D",
        desColor: "#000000",
        link: "",
      },
      {
        title: "Freshly Baked Bread",
        des1: "Our Bakers are up bright and early every morning to ensure you receive the best quality and freshly baked bread possible",
        des2: "Sandwich Loaves, dinner rolls or a premium vienna loaf are just a few breads Banjo’s Beerwah offers.",
        btnText: "BREAD",
        btnBgColor: "#9A8260",
        btnColor: "#ffffff",
        titleColor: "#9A8260",
        desColor: "#000000",
        link: "",
      },
      {
        title: "Coffee in Beerwah",
        des1: "At Banjo’s, we take coffee seriously. We’re coffee lovers just like you and we take pride in our craft. Visit us at Banjo’s Beerwah for barista made coffee made with a UTZ certified blend.",
        des2: "Pre-order your morning coffee with the Banjo’s App below",
        btnText: "COFFEE",
        btnBgColor: "#564845",
        btnColor: "#ffffff",
        titleColor: "#564845",
        desColor: "#000000",
        link: "",
      },
      {
        title: "Hot Savouries",
        des1: "At Banjo’s, we take coffee seriously. We’re coffee lovers just like you and we take pride in our craft. Visit us at Banjo’s Beerwah for barista made coffee made with a UTZ certified blend",
        des2: "Pre-order your morning coffee with the Banjo’s App below",
        btnText: "HOT SAVOURY",
        btnBgColor: "#A04D3D",
        btnColor: "#ffffff",
        titleColor: "#A04D3D",
        desColor: "#000000",
        link: "",
      },
      {
        title: "For the Sweet Tooth",
        des1: "Croissants, muffins, danishes, cakes, slices & more, Banjo’s Beerwah has something for every sweet tooth.",
        des2: "Still unsure? Grab 5 of your favourite slices for just $10.95 or try our 4 Danish or Muffin deals for only $14.95!",
        btnText: "SWEET",
        btnBgColor: "#3B513D",
        btnColor: "#ffffff",
        titleColor: "#3B513D",
        desColor: "#000000",
        link: "",
      },
      {
        title: "Fresh Salad Lunch",
        des1: "Prepared Fresh everyday, Banjo's has a selection of sandwiches and salad rolls for every set of taste buds",
        des2: "A classic Ham Salad Sandwich for $X or a Chicken Ceasar Long Roll for $X, that's lunch sorted!",
        btnText: "BREAD",
        btnBgColor: "#9A8260",
        btnColor: "#ffffff",
        titleColor: "#9A8260",
        desColor: "#000000",
        link: "",
      },
    ],
    weAreAvailable: [
      {
        show: true,
        btnColor: "#ffffff",
        link: "",
        logo: "https://banjosdev.codinghands.in/storage/jSQFu1HKKTDFrOSBYNMbP7GCAVq2R9YBdbscrn1n.jpg",
      },
      {
        show: true,
        btnColor: "#ffffff",
        link: "",
        logo: "https://banjosdev.codinghands.in/storage/h5jPNKAUSFVIu1AJiZ003Y3DYaMGAaUfhF2OSJ4o.jpg",
      },
    ],
    proudlySupp: [
      {
        show: true,
        btnColor: "#ffffff",
        link: "",
        logo: "https://banjosdev.codinghands.in/storage/60W7ctL63QoyrUtvMKSmYemHHTKAqvsKMbpME97M.jpg",
      },
      {
        show: true,
        btnColor: "#ffffff",
        link: "",
        logo: "https://banjosdev.codinghands.in/storage/A4p74mFCCmTutstb1cWKazfLYkYTBXb3INLNdqF5.jpg",
      },
      {
        show: true,
        btnColor: "#ffffff",
        link: "",
        logo: "https://banjosdev.codinghands.in/storage/iSYoxn9qRAjg9cnnigtqTithztczFTy9njjNzHJj.jpg",
      },
    ],
    isSectionVisible: {
      mainBanner: true,
      orderSection: true,
      banner2: true,
      textSection: true,
      banner3: true,
      orderOnlineSection: true,
      favouriteSection: true,
      deliveryPartners: true,
      supporterSection: true,
    },
  },
};
